<div class="main-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner"></div>
    <p>Loading support information...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="errorMessage && !isLoading" class="error-container">
    <p class="error-message">{{ errorMessage }}</p>
    <button (click)="loadSupportData()" class="retry-btn">Retry</button>
  </div>

  <!-- Content -->
  <div *ngIf="!isLoading && !errorMessage && supportData">
    <div class="content">
      <h2 class="page-header">Support</h2>
      <!-- Page Header -->
      <header class="support-header">
        <p class="support-subtitle">Need assistance or have questions? Reach out to us anytime. Our team is always happy to help.</p>
      </header>

      <div class="support-content">
        <!-- Map Section with Contact Cards -->
        <div class="map-section">
          <img src="assets/img/support-map.png" alt="Location Map" class="map-image">
          
          <!-- Contact Cards Overlay -->
          <div class="contact-cards">
            <!-- Address Card -->
            <div class="contact-card address-card">
              <div class="card-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div class="card-content">
                <h3>Address</h3>
                <p>{{ supportData.locationAddress }}</p>
              </div>
            </div>

            <!-- Email Card -->
            <div class="contact-card email-card">
              <div class="card-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="20" height="16" x="2" y="4" rx="2"/>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                </svg>
              </div>
              <div class="card-content">
                <h3>Email</h3>
                <p>
                  <a [href]="'mailto:' + supportData.emailSupport">{{ supportData.emailSupport }}</a>
                </p>
              </div>
            </div>

            <!-- Phone Card -->
            <div class="contact-card phone-card">
              <div class="card-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 18H12.01" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="card-content">
                <h3>Phone</h3>
                <p>For Support: <a [href]="'tel:' + supportData.phoneSupport">{{ supportData.phoneSupport }}</a></p>
              </div>
            </div>
          </div>

          <!-- Location Marker -->
          <!-- <div class="location-marker">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="#f16f05" stroke="none">
              <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
          </div> -->
          <div class="location-marker">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" stroke="none"> 
        
        <defs>
          <linearGradient id="locationGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style="stop-color:#f8a917; stop-opacity:1" /> <stop offset="100%" style="stop-color:#ff3737; stop-opacity:1" /> </linearGradient>
        </defs>

        <path fill="url(#locationGradient)" fill-rule="evenodd" 
              d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0ZM12 13a3 3 0 1 0 0-6a3 3 0 0 0 0 6Z" />
        
      </svg>
    </div>
        </div>
      </div>
      <!-- Footer Note -->
      <div class="support-footer">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="globe-icon">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/>
          <path d="M2 12h20"/>
        </svg>
        <p>
          For more information, please visit
          <a [href]="'https://' + supportData.website" target="_blank" rel="noopener noreferrer">{{ supportData.website }}</a>
        </p>
      </div>
    </div>
  </div>
</div>
